//Set the baseURLEndpoint depending on the version of the application.
//const baseApiEndPointUrl = 'https://tx-school-city-data-api.herokuapp.com/';
const baseApiEndPointUrl = 'https://tx-school-city-data-engine-api.herokuapp.com/';

//Global static application settings
export const appDataStore = {
  //Axios settings
  axiosConfig: {
    timeout: 0,
    //withCredentials: true,
  },

  //Api endpoint references
  apiConfig: {
    SchoolSuperSalary: {
      url: baseApiEndPointUrl + 'api/school/super-salary',
    },
    AuthSignUp: {
      url: baseApiEndPointUrl + 'api/auth/signup',
    },
    AuthLogin: {
      url: baseApiEndPointUrl + 'api/auth/login',
    },
  },
};
